import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface RotatingTextProps {
  text: string[];
  duration?: number;
  transition?: {
    duration?: number;
    ease?: string;
  };
  className?: string;
}

export const RotatingText: React.FC<RotatingTextProps> = ({
  text,
  duration = 3000,
  transition = { duration: 0.5, ease: 'easeInOut' },
  className = '',
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (text.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % text.length);
    }, duration);

    return () => clearInterval(interval);
  }, [text.length, duration]);

  if (text.length === 0) return null;

  return (
    <div className={`relative inline-block overflow-hidden ${className}`}>
      <AnimatePresence mode="wait">
        <motion.div
          key={currentIndex}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{
            duration: transition.duration || 0.5,
            ease: transition.ease || 'easeInOut',
          }}
          className="inline-block"
        >
          {text[currentIndex]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

